import { render, staticRenderFns } from "./CustExtOrder.vue?vue&type=template&id=c2ea0d3e&scoped=true"
import script from "./CustExtOrder.vue?vue&type=script&lang=js"
export * from "./CustExtOrder.vue?vue&type=script&lang=js"
import style0 from "./CustExtOrder.vue?vue&type=style&index=0&id=c2ea0d3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ea0d3e",
  null
  
)

export default component.exports